jQuery(document).ready(function ($) {
    
    //link filters
    $('.filters .filter').on('click', function () {
        $(this).toggleClass('active');
    });    

    $('.filters .btn-filter-submit').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.filters').addClass('busy');
        
        ajaxFilter();
    });


    $('.tab-filters .btn-apply-filters').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.tab-filters').addClass('busy');
        
        ajaxTabFilters();

        $('#filterTabs .nav-link.active').removeClass('active');
        $('#filterTabContent .tab-pane.active.show').removeClass('active').removeClass('show');
        $('.btn-filter-apply').hide();
        $('.filters-overlay').hide();
        $('.popup-overlay').click();
        document.body.classList.remove('no-scroll');
    });


    //select filters
    $('.filters .filter-select').change(function(){
    });
	//pagination
    $(document).on('click', '.pagination.ajax a', function(e){
        e.preventDefault();
        var page = $(this).data('page');
		
        ajaxFilter(page);
    });
    
    //ajax request
	function ajaxFilter(page){
		var page = page || 1;
        
        var origin = $('#filter-origin').val();
        if(origin !== ''){
            var selected_filters = {
                'thematiques': [],
                'clients': [],
                'secteurs': [],
                'filiales' : [],
                'secteur' : [],
                'typepub' : [],
                
            };
            //get all selected filters
            $('.filters .filter.active').each(function(){
                selected_filters[$(this).data('filter')].push($(this).data('value'));
            });
            
            $('.filters .filter-select').each(function(){
                if($(this).val() !== ''){
                    selected_filters[$(this).data('filter')].push($(this).val());
                }
            });

            $.ajax({
                url: ajaxurl,
                type: 'GET',
                dataType: 'html',
                data: {
                    action: 'filter',
                    origin: origin,
                    lang: $('#filter-lang').val(),
                    filters: selected_filters,  
                    paged: page,
                    view: $('.view-switcher span.active').length == 1 ? $('.view-switcher span.active').data('vue') : false
                }
            })
            .done(function (response) {
                $('.filters').removeClass('busy');
                if(response){                    
                    $("#list").hide().html(response).fadeIn(500);
                    $('html, body').animate({
                        scrollTop: $("#list").offset().top - 25
                    }, 500);
                    if($('.grid').length){
                        var msnry = new Masonry( '.grid', {
                            //columnWidth: 200,
                            gutter: 32,
                            itemSelector: '.card'
                        });
                    }
                }
            })
            .fail(function (jqXHR, error) {
                console.log('error : ' + error);
            });
        }
        else{
            console.log('NO origin for filters');
        }
	}


        //ajax request
	function ajaxTabFilters(page){
		var page = page || 1;
        
        var origin = $('#filter-origin').val();
        if(origin !== ''){
            var selected_filters = {
                'secteurs': [],
                'filiales' : [],
                
            };
            //get all selected filters
            
            $('.filters-wrap input[name^=filter-]:checked').each(function(){
                var filterName = $(this).attr('name').replace('filter-', '');
                selected_filters[filterName].push($(this).val()); 
            });

            $.ajax({
                url: ajaxurl,
                type: 'GET',
                dataType: 'html',
                data: {
                    action: 'filter',
                    origin: origin,
                    lang: $('#filter-lang').val(),
                    filters: selected_filters,  
                    paged: page,
                    view: $('.view-switcher span.active').length == 1 ? $('.view-switcher span.active').data('vue') : false
                }
            })
            .done(function (response) {
                $('.filters').removeClass('busy');
                if(response){                    
                    $("#list").hide().html(response).fadeIn(500);
                    $('html, body').animate({
                        scrollTop: $("#list").offset().top - 25
                    }, 500);
                    if($('.grid').length){
                        var msnry = new Masonry( '.grid', {
                            //columnWidth: 200,
                            gutter: 32,
                            itemSelector: '.card'
                        });
                    }
                }
            })
            .fail(function (jqXHR, error) {
                console.log('error : ' + error);
            });
        }
        else{
            console.log('NO origin for filters');
        }
	}

    /**  New filter tabs 2024 **/
    // hide tabcontent for already active clicked tab
    $(document).on('click', '#filterTabs .nav-link.active', function() {
        $(this).removeClass('active');
        $('#filterTabContent .tab-pane.active.show').removeClass('active').removeClass('show');
        $('.btn-filter-apply').hide();
        $('.btn-filter-reset').hide();
        $('.filters-overlay').hide();
        document.body.classList.remove('no-scroll');
    });

    $(document).on('click', '#ref-filters #filterTabs .nav-link:not(.active)', function() {
        $('#ref-filters').css('position', 'fixed');
        $('#ref-filters').css('top', '32px');
        $('.filters-overlay').show();
        document.body.classList.add('no-scroll');
        var filter_all_selected_count = $('.filters-wrap input[name^=filter-]:checked');
        if(filter_all_selected_count.length > 0) {
            $('.btn-filter-apply').show();
        } else {
            $('.btn-filter-apply').hide();
        }
    });
    
    $(document).on('click', '.filters-overlay', function() {
        $('.filters-overlay').hide();
        $('#ref-filters').css('position', 'relative');
        $('#ref-filters').css('top', 'auto');
        $('#filterTabContent .tab-pane.active.show').removeClass('active').removeClass('show');
        $('#filterTabs .nav-link.active').removeClass('active');
        $('.btn-filter-apply').hide();
        document.body.classList.remove('no-scroll');
    });

    $(document).on('click', '.popup-overlay', function() {
        $('.btn-filter-apply').hide();
        $('.popup-overlay').hide();
        document.body.classList.remove('no-scroll');
        let animationSpeed = parseInt(filter_popup_animation_speed);
        $('.filter-popup').animate({bottom: '-'+filter_popup_vh+'vh'}, animationSpeed);
        setTimeout(function() {
            $('.filter-popup').hide();
        }, animationSpeed);
    });
    // update count of filters selected
    $(document).on('click', '.filter-button', function() {
        var filter_input = $(this).siblings('input'); // get clicked element
        var filter_name = filter_input.attr("name"); // get clicked element name
        var filter_type = filter_name.split('-'); // explode to get filter type name

        // setTimeout necessary because element clicked is not the input and the checked test might not be instantaneous
        setTimeout(function() {
            var filter_selected_count = $('input[name='+filter_name+']:checked'); // get number of selected filter in this filter type
            // update the front fields
            if(filter_selected_count.length > 0) {
                $('#'+filter_type[1]+'-tab .count').html('('+filter_selected_count.length+')');
                $('#'+filter_type[1]+'-wrap .accordion-button .count').html('('+filter_selected_count.length+')');
            } else {
                $('#'+filter_type[1]+'-tab .count').html('');
                $('#'+filter_type[1]+'-wrap .accordion-button .count').html('');
            }

            // update the field for all selected filters count
            var filter_all_selected_count = $('.filters-wrap input[name^=filter-]:checked');
            if(filter_all_selected_count.length > 0) {
                $('#show-filters-mob .count').html('('+filter_all_selected_count.length+')');
                $('.btn-filter-apply').show();
                $('.btn-filter-reset').show();
            } else {
                $('#show-filters-mob .count').html('');
                $('.btn-filter-apply').hide();
                $('.btn-filter-reset').hide();
            }
        }, 100);
    });

    // sliding filter popup trigger 
    if(is_mobile) {
        let animationSpeed = parseInt(filter_popup_animation_speed);
        $(document).on('click', '#show-filters-mob', function() {
            document.body.classList.add('no-scroll');
            $('.popup-overlay').show();
            $('.filter-popup').show().animate({bottom: 0}, animationSpeed); 
            var filter_all_selected_count = $('.filters-wrap input[name^=filter-]:checked');
            if(filter_all_selected_count.length > 0) {
                $('.btn-filter-apply').show();
            } else {
                $('.btn-filter-apply').hide();
            }
        });

        // hide popup on close or swipe !!!
        document.getElementById('swipe-close').addEventListener('swiped-down', function(e) {
            // console.log(e.target); // the element that was swiped

            $('.popup-overlay').hide();
            document.body.classList.remove('no-scroll');
            $('.filter-popup').animate({bottom: '-'+filter_popup_vh+'vh'}, animationSpeed);
            setTimeout(function() {
                $('.filter-popup').hide();
            }, animationSpeed);
        });
    }
    if(is_mobile !== true) {
        $(document).on('click', '#show-filters-mob', function() {
            $('.hide-fake-mob').slideToggle();
        });
    }/* else {
        $('.popup-overlay').hide();
        $('.filter-popup').hide()
        $('.hide-fake-mob').show();
    }*/

        
    $(document).on('click', '.btn-reinit', function() {
        /*$('.filters-wrap input[name^=filter-]:checked').prop('checked', false).change();
        $('#filterTabs .nav-link .count').html('');
        $('#filterTabs .accordion-button .count').html('');
        $('#show-filters-mob .count').html('');
        $('.tab-filters .btn-apply-filters').click();
        $('.btn-filter-reset').hide();*/
        window.location.reload();
    });
    
});


